var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-container" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "login-right" }, [
      _c(
        "div",
        { staticClass: "login-card" },
        [
          _c("div", { staticClass: "form-title" }, [_vm._v("gaga小程序")]),
          _vm._v(" "),
          _c(
            "el-tabs",
            {
              attrs: { stretch: "" },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "账号密码登录", name: "input-pwd" } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "loginForm",
                      staticClass: "login-form",
                      attrs: {
                        model: _vm.loginForm,
                        rules: _vm.loginRules,
                        "auto-complete": "on",
                        "label-position": "left",
                      },
                      on: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleLogin($event)
                        },
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "input-item",
                          attrs: { prop: "username" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "input-prefix" },
                            [
                              _c("svg-icon", {
                                attrs: { "icon-class": "long" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.loginForm.username,
                                expression: "loginForm.username",
                              },
                            ],
                            ref: "username",
                            staticClass: "login-input",
                            attrs: {
                              name: "username",
                              placeholder: "请输入用户名",
                              type: "text",
                            },
                            domProps: { value: _vm.loginForm.username },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.loginForm,
                                  "username",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          staticClass: "input-item",
                          attrs: { prop: "password" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "input-prefix" },
                            [
                              _c("svg-icon", {
                                attrs: { "icon-class": "mima" },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.passwordType === "checkbox"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.loginForm.password,
                                    expression: "loginForm.password",
                                  },
                                ],
                                ref: "password",
                                staticClass: "login-input",
                                attrs: {
                                  name: "password",
                                  autocomplete: "on",
                                  placeholder: "请输入密码",
                                  type: "checkbox",
                                },
                                domProps: {
                                  checked: Array.isArray(_vm.loginForm.password)
                                    ? _vm._i(_vm.loginForm.password, null) > -1
                                    : _vm.loginForm.password,
                                },
                                on: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.handleLogin($event)
                                  },
                                  change: function ($event) {
                                    var $$a = _vm.loginForm.password,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.loginForm,
                                            "password",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.loginForm,
                                            "password",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.loginForm, "password", $$c)
                                    }
                                  },
                                },
                              })
                            : _vm.passwordType === "radio"
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.loginForm.password,
                                    expression: "loginForm.password",
                                  },
                                ],
                                ref: "password",
                                staticClass: "login-input",
                                attrs: {
                                  name: "password",
                                  autocomplete: "on",
                                  placeholder: "请输入密码",
                                  type: "radio",
                                },
                                domProps: {
                                  checked: _vm._q(_vm.loginForm.password, null),
                                },
                                on: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.handleLogin($event)
                                  },
                                  change: function ($event) {
                                    return _vm.$set(
                                      _vm.loginForm,
                                      "password",
                                      null
                                    )
                                  },
                                },
                              })
                            : _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.loginForm.password,
                                    expression: "loginForm.password",
                                  },
                                ],
                                ref: "password",
                                staticClass: "login-input",
                                attrs: {
                                  name: "password",
                                  autocomplete: "on",
                                  placeholder: "请输入密码",
                                  type: _vm.passwordType,
                                },
                                domProps: { value: _vm.loginForm.password },
                                on: {
                                  keyup: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "enter",
                                        13,
                                        $event.key,
                                        "Enter"
                                      )
                                    ) {
                                      return null
                                    }
                                    return _vm.handleLogin($event)
                                  },
                                  input: function ($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.loginForm,
                                      "password",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "show-pwd",
                              on: { click: _vm.showPwd },
                            },
                            [
                              _c("svg-icon", {
                                attrs: {
                                  "icon-class":
                                    _vm.passwordType === "password"
                                      ? "eye"
                                      : "eye-open",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.loginForm.rememberMe,
                                callback: function ($$v) {
                                  _vm.$set(_vm.loginForm, "rememberMe", $$v)
                                },
                                expression: "loginForm.rememberMe",
                              },
                            },
                            [_vm._v("记住密码")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "login-btn",
                              attrs: { type: "primary", loading: _vm.loading },
                              nativeOn: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.handleLogin($event)
                                },
                              },
                            },
                            [_vm._v("\n                登录\n              ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-tab-pane",
                { attrs: { label: "企业微信登录", name: "wework" } },
                [
                  _c(
                    "div",
                    { staticClass: "wework-container" },
                    [
                      _vm.activeName === "wework"
                        ? _c("we-work-login-pane")
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "login-left" }, [
      _c("div", { staticClass: "brand-container" }, [
        _c("h1", { staticClass: "brand-name" }, [_vm._v("gaga管理平台")]),
        _vm._v(" "),
        _c("p", { staticClass: "brand-slogan" }, [
          _vm._v("让工作更高效，让生活更简单"),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }